import { useLocation } from 'react-router-dom';
import { pluginSettingsVar } from '../apollo/store';
import { useMemo } from 'react';
import { Address } from 'gql/__generated/vp-apollo';

type LocationState = {
    address?: Address;
};

export const useAddressToCheck = () => {
    const { state } = useLocation();
    const pluginSettings = pluginSettingsVar();

    return useMemo<Address | null>(
        () => (state as LocationState)?.address || pluginSettings?.address || null,
        [state, pluginSettings]
    );
};
